import { addDays, format, isEqual, isSameDay, startOfHour, subDays, subMilliseconds } from 'date-fns';
import { TFunction } from 'i18next';
import parseMilliseconds from 'parse-ms';

import { DateType } from '../types';

// transform value retrieved from date-picker to match soft range boundaries (open interval)
export const createEndOfDateRange = (input: DateType) => addDays(new Date(input), 1);

// roll over to value used by datePicker
export const convertFieldsEndOfDateRange = (date: DateType) => subDays(new Date(date), 1);

// removes 1 millisecond if date is represented as an open interval value
export const handleEndOfDateRange = (inputDate: DateType) => {
  const date = new Date(inputDate);

  return isEqual(startOfHour(date), date) ? subMilliseconds(date, 1) : date;
};

export const dateRangeToFormattedString = (
  startDate: DateType,
  endDate: DateType,
  dateFormat: string,
  localeObj?: Locale
) => {
  const dateFrom = new Date(startDate);
  const dateTo = handleEndOfDateRange(endDate);
  const formattedDateFrom = format(dateFrom, dateFormat, { locale: localeObj });
  const formattedDateTo = format(dateTo, dateFormat, { locale: localeObj });

  return isSameDay(dateFrom, dateTo) ? formattedDateFrom : `${formattedDateFrom} - ${formattedDateTo}`;
};

// Convert seconds/ms to 1d 50h 10m 5s like localized string format
export const formatSecondsToReadableForm = (secondsToParse: number, t: TFunction, omitSeconds = false) => {
  const { days, hours, minutes, seconds } = parseMilliseconds(secondsToParse * 1000);

  const daysPretty = days > 0 ? `${days}${t('time.compactUnits.day')} ` : '';
  const hoursPretty = hours > 0 || daysPretty ? `${hours}${t('time.compactUnits.hour')} ` : '';
  const minutesPretty =
    minutes > 0 || hoursPretty ? `${minutes}${t('time.compactUnits.minute')}${omitSeconds ? '' : ' '}` : '';
  const secondsPretty = `${seconds}${t('time.compactUnits.second')}`;

  return `${daysPretty}${hoursPretty}${minutesPretty}${omitSeconds ? '' : secondsPretty}`;
};

// Convert hours/minutes selected duration value into minutes/seconds
export const convertToMinutesSeconds = (timeToParse: number) => {
  const { hours, minutes } = parseMilliseconds(timeToParse * 1000);

  const newMinutes = hours * 60;
  const newSeconds = minutes;

  return newMinutes + newSeconds;
};

// Convert minutes/seconds duration value into hours/minutes
export const convertToHoursMinutes = (timeToParse: number) => {
  const { minutes, seconds } = parseMilliseconds(timeToParse * 1000);

  const hours = minutes * 60 * 60;
  const newMinutes = seconds * 60;

  return hours + newMinutes;
};
